<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">Edit Assessments Details</h1>
   <!-- <div class="btn-toolbar mb-2 mb-md-0">
       <div class="btn-group">
          <!-- goBack() methos to back to previous component 
          <button class="btn btn-sm btn-outline-secondary" (click)="goBack()">Go Back</button>
       </div>
    </div>-->
</div>
<form [formGroup]="assessmentForm" novalidate (ngSubmit)="updateAssessmentForm()">
  <div *ngIf="buttonShow">
    <div class="pt-20"></div>
    <div class="center">
      <img src="../../../assets/imgs/icon.png" class="img-fluid2 logo-icon-resize">
    </div>

    <h2 id="b2borb2c" class="h2-blue-light">Welcome</h2>
    <!---
    <div class="btn-group">
      <button mat-raised-button class="selectButt" type="button"
        [style.background-color]="toggleHigh ? '#3e51b5' : 'white'" [style.color]="toggleHigh ? 'white' : 'black'"
        (click)="toggleBusinessQuestionShow()"> High Growth Startup </button>
      <button mat-raised-button class="selectButt" type="button"
        [style.background-color]="toggleMaintain ? '#3e51b5' : 'white'"
        [style.color]="toggleMaintain ? 'white' : 'black'" (click)="toggleBusinessQuestionHide()"> Maintain a Small
        Business </button>
    </div>
  -->
    <p id="b2borb2c" class="sub-txt">Are you selling to consumers or to other businesses?</p>
    <div class="pt-2"></div>
    <div class="btn-group">
      <button mat-raised-button class="btn-blue-royal" (click)="toggleB2B()"> Business to Business </button>
      <button mat-raised-button class="btn-blue-light" (click)="toggleB2C()"> Business to Consumer </button>
    </div>
    <div class="pt-2"></div>
    <p id="note">Fill out ALL questions, feel free to take a best guess if you don't know the answer</p>
  </div>

  <div *ngIf="showAll">
    <mat-tab-group [selectedIndex]="tabNum">

      <!--Business information-->
      <mat-tab label="Business Information">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Business Information</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Business Name" formControlName="busiName">
                  <mat-error *ngIf="assessmentForm.controls['busiName'].hasError('required')">
                    Business Name is
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-select placeholder="Business Registration" formControlName="busiRegType">
                    <mat-option *ngFor="let registration of busiRegType" [value]="registration">
                      {{ registration.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['busiRegType'].hasError('required')">
                    Registration Type
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="First name" formControlName="busiFirstName">
                  <mat-error *ngIf="assessmentForm.controls['busiFirstName'].hasError('required')">
                    First name is
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Last name" formControlName="busiLastName">
                  <mat-error *ngIf="assessmentForm.controls['busiLastName'].hasError('required')">
                    Last name is
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Email" type="email" formControlName="busiEmail">
                  <mat-error *ngIf="assessmentForm.controls['busiEmail'].hasError('required')">
                    Email
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Phone Number" type="text" formControlName="busiTelephone">
                  <mat-error *ngIf="assessmentForm.controls['busiTelephone'].hasError('required')">
                    Phone number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Website" type="text" formControlName="busiWebsite">
                </mat-form-field>
              </div>
            </div>
            <!--  <div class="row">
          <div class="col">
            <mat-form-field class="full-width">
              <textarea matInput placeholder="Street" formControlName="busiStreet"></textarea>
              <mat-error *ngIf="assessmentForm.controls['busiStreet'].hasError('required')">
                Address is
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width">
              <input matInput placeholder="City" formControlName="busiCity">
              <mat-error *ngIf="assessmentForm.controls['busiCity'].hasError('required')">
                City is
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="!hasUnitNumber">
          <div class="col">
            <button mat-button type="button" (click)="hasUnitNumber = !hasUnitNumber">
              + Add C/O, Apt, Suite, Unit
            </button>
          </div>
        </div>
        <div class="row" *ngIf="hasUnitNumber">
          <div class="col">
            <mat-form-field class="full-width">
              <textarea matInput placeholder="Address 2" formControlName="busiaddress2"></textarea>
            </mat-form-field>
          </div>
        </div> -->
            <div class="row">

              <!--  <div class="col">
            <mat-form-field class="full-width">
              <mat-select placeholder="State" formControlName="busiState">
                <mat-option *ngFor="let state of states" [value]="state.abbreviation">
                  {{ state.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="assessmentForm.controls['busiState'].hasError('required')">
                State is
              </mat-error>
            </mat-form-field>
          </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput #postalCode maxlength="5" placeholder="Postal Code" type="number"
                    formControlName="busiZipcode">
                  <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
                  <mat-error *ngIf="assessmentForm.controls['busiZipcode'].hasError('required')">
                    What is your postal code?
                  </mat-error>
                </mat-form-field>
              </div>
              <!--  <div class="col">
            <mat-form-field class="full-width">
              <mat-select placeholder="Choose the area that your business is concentrated in" formControlName="busiLocation" multiple>
                <mat-option *ngFor="let location of busiLocation" [value]="location">
                  {{ location.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="assessmentForm.controls['busiLocation'].hasError('required')">
                Select one
              </mat-error>
            </mat-form-field>
          </div>-->
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-select placeholder="Preferred Contact Method" formControlName="busiContactby">
                    <mat-option *ngFor="let method of contactMethod" [value]="method">
                      {{ method }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['busiContactby'].hasError('required')">
                    How should we contact you?
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput #referredBy placeholder="Referred by" formControlName="busiReferredBy">
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label> Please select all that apply </label>
                  <mat-select placeholder="" formControlName="busiDemographics" multiple>
                    <mat-option *ngFor="let busiDemo of busiDemographics" [value]="busiDemo">
                      {{busiDemo.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['busiDemographics'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
        <button mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button" (click)="nextTab()">Next
          <mat-icon> keyboard_arrow_right</mat-icon>
        </button>
      </mat-tab>

      <!--product information-->
      <mat-tab label="Product Information">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Your Business Features</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label> 1a. What is your business primarily offering?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Ex. Bookkeeping is a service; a book is a product">info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerType">
                    <mat-option  *ngFor="let offer of offerType" [value]="offer">
                      {{offer.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerType'].hasError('required')">
                    Please select an offering type
                  </mat-error>
                </mat-form-field>
              </div>
              
              <div class="col">
                <mat-form-field class="full-width">
                  <label> 2. What industry is your business in? </label>
                  <mat-select placeholder="" formControlName="offerIndustry">
                    <mat-option (onSelectionChange)="handleNighttimeEconomyQ1($event, industry.name)" 
                    *ngFor="let industry of offerIndustry" [value]="industry">
                      {{industry.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerIndustry'].hasError('required')">
                    Please select an industry
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" #iNEQ1 style="display:none">
                <mat-form-field class="full-width">
                  <label> 2a. What will you be serving? </label>
                  <mat-select placeholder="" formControlName="industryNEServing" multiple>
                    <mat-option *ngFor="let NEServing of industryNEServing" [value]="NEServing">
                      {{NEServing.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['industryNEServing'].hasError('required')">
                    Please select an industry
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>How Big is the Problem You're Solving?</h3>
            </label>
            <!--problem importance-->
            <div class="row">
              <!-- <div class="col">
          <mat-form-field class="full-width">
          <label>What condition is the market size compared to others?</label>
          <mat-select placeholder="" formControlName="offerMarkSize">
          <mat-option *ngFor="let oMarkSize of offerMarkSize" [value]="oMarkSize">
          {{oMarkSize.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="assessmentForm.controls['offerMarkSize'].hasError('required')">
      Please select offer market size
    </mat-error>
  </mat-form-field>
</div>-->
              <!--<div class="col">
                <mat-form-field class="full-width">
                  <label>3. Would your business have been classified as essential during the COVID-19 pandemic?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Ex. Daycare or medical services">info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerEssential">
                    <mat-option *ngFor="let oEssential of offerEssential" [value]="oEssential"><!--  changetag
                    {{oEssential.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerEssential'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <label>3. How frequent would your customer buy from your business?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Example: A rider rides the bus (the offering) twice a day">info
                    </mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerFrequency">
                    <mat-option *ngFor="let oFrequency of offerFrequency" [value]="oFrequency">
                      {{oFrequency.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerFrequency'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>4. How high of a priority would your product or service rank in your customer's monthly budget?
                  </label>
                  <!--changetag -->
                  <!--  <a class="modal-click" (click)="modal.openSDGHelp()">
                    <mat-icon matSuffix>info</mat-icon>
                  </a>-->
                  <mat-select placeholder="" formControlName="offerUrgency">
                    <mat-option *ngFor="let oUrgency of offerUrgency" [value]="oUrgency">
                      {{oUrgency.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerUrgency'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>How is Your Product or Service Different?</h3>
            </label>
            <!--offer innovation-->
            <div class="row">
              <div *ngIf="showQuestion" class="col">
                <!--<a class="modal-click" (click)="modal.openOfferHelp()">
    <mat-icon matSuffix>info</mat-icon>
  </a>-->
                <mat-form-field class="full-width">
                  <label>5. Which situation best relates to your business idea/model? Finish the sentence, "My business..."
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Example: The first ride sharing app was much different than the regular taxi business ">
                      info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerInnovation">
                    <mat-option *ngFor="let oInnovation of offerInnovation" [value]="oInnovation">
                      {{oInnovation.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerInnovation'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>6. How is your business different than competitors?
                      <mat-icon class="matTooltip" matSuffix
                        matTooltip="Differentiation is how the offering may differ from competitors or substitutes">info
                      </mat-icon>
                    </label>
                    <mat-select placeholder="" formControlName="offerDifferentiation" multiple>
                      <mat-option (onSelectionChange)="diffChange($event, oDiff.name)"
                        *ngFor="let oDiff of offerDifferentiation" [value]="oDiff">
                        {{oDiff.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['offerDifferentiation'].hasError('required')">
                      Please select one differentiation
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>7. If any, what part of the customer’s life will improve because of your business?</label>
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Think about how it may relate to their survival, income or convenience">info
                    </mat-icon>
                    <mat-select placeholder="" formControlName="offerImproveLife" multiple>
                      <mat-option *ngFor="let oImproveLife of offerImproveLife" [value]="oImproveLife">
                        {{ oImproveLife.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['offerImproveLife']">
                      Please select all that apply
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            <label>
              <h3>What is the Condition of Your Industry?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>8. What barriers could you possibly run into while starting or operating this business? Select all that
                    apply</label>
                  <a class="modal-click" (click)="modal.openMarkEntryHelp()">
                    <mat-icon class="matTooltip" matSuffix>info</mat-icon>
                  </a>
                  <mat-select placeholder="" formControlName="offerMarkEntry" multiple name="my-select">
                    <mat-option (onSelectionChange)="selectChange($event, markEntry.name)"
                      *ngFor="let markEntry of offerMarkEntry" [value]="markEntry">
                      {{markEntry.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerMarkEntry'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <mat-form-field class="full-width">
                  <label>9. Buyer Power is the power your customer has to demand a lower price from you or higher quality. How much Buyer Power does your customer have?
                    <!--TODO - how vulnerable are your sales to price sensitivty, if the price were to change, how many customers would stay vs leave?-->
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="If one customer demanded higher quality, how much pressure would they have to exert to get their way?">
                      info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerBuyerPower">
                    <mat-option *ngFor="let oBuyerPower of offerBuyerPower" [value]="oBuyerPower">
                      {{oBuyerPower.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerBuyerPower'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>10. How easy would it be to switch suppliers if you needed to?
                    <!--TODO - how vulnerable are your sales to price sensitivty, if the price were to change, how many customers would stay vs leave?-->
                  </label>
                  <mat-select placeholder="" formControlName="offerSupplierPower">
                    <mat-option *ngFor="let oSupplierPower of offerSupplierPower" [value]="oSupplierPower">
                      {{oSupplierPower.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerSupplierPower'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>11. Who are the suppliers for your most profitable products/services?</label>
                  <!--TODO--How vulnerable is the success of your business to supplier price changes?.maybe?...or is it a big chain?-->
                  <mat-select placeholder="" formControlName="offerSupplierType" multiple>
                    <mat-option *ngFor="let oSupplierType of offerSupplierType" [value]="oSupplierType">
                      {{ oSupplierType.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerSupplierType']">
                    Please select all that apply
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
        <button type="button" mat-raised-button class="btn-blue-royal next-btn" color="primary" (click)="nextTab()">Next
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button type="button" mat-raised-button class="btn-blue-royal prv-btn" color="primary" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon> Previous
        </button>
      </mat-tab>

      <!--Market-->
      <mat-tab label="Market">
        <mat-card class="card">
          <!-- Busines to Business-->
          <div *ngIf="B2B">
            <mat-card-header>
              <mat-card-title>Target Market</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <label>
                <h3>Understanding Your Target Customer</h3>
              </label>
              <div class="row">
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>1. What is the main target customer's occupation?</label>
                    <mat-select placeholder="" formControlName="marketTargetOccupation">
                      <mat-option *ngFor="let mTargetOccupation of marketTargetOccupation" [value]="mTargetOccupation">
                        {{ mTargetOccupation.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetOccupation'].hasError('required')">
                      Please enter the target occupation
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>2. What's the largest market location you could potentially serve? </label>
                    <mat-select placeholder="" formControlName="marketTargetLocation">
                      <mat-option *ngFor="let mTargetLocation of marketTargetLocation" [value]="mTargetLocation">
                        {{mTargetLocation.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetLocation'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>3. What is the target business industry?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BIndustry">
                      <mat-option *ngFor="let mmarketTargetB2BIndustry of marketTargetB2BIndustry"
                        [value]="mmarketTargetB2BIndustry">
                        {{mmarketTargetB2BIndustry.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BIndustry'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
             <!--  <div class="col">
                  <mat-form-field class="full-width">
                    <label>4. What is the target business size?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BSize">
                      <mat-option *ngFor="let mmarketTargetB2BSize of marketTargetB2BSize"
                        [value]="mmarketTargetB2BSize">
                        {{mmarketTargetB2BSize.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BSize'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>-->
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>5. Who is your point of contact within the organization that you are selling to?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BOccupation">
                      <mat-option *ngFor="let mmarketTargetB2BOccupation of marketTargetB2BOccupation"
                        [value]="mmarketTargetB2BOccupation">
                        {{mmarketTargetB2BOccupation.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BIndustry'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>6. Is the point of contact a decision maker within the organization?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BDecisionMaker">
                      <mat-option *ngFor="let mmarketTargetB2BDecisionMaker of marketTargetB2BDecisionMaker"
                        [value]="mmarketTargetB2BDecisionMaker">
                        {{mmarketTargetB2BDecisionMaker.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BDecisionMaker'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <label>
                <h3>Understanding Your Competitors</h3>
              </label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>7. How many known competitors, or substitutes, do you have? </label>
                    <mat-select placeholder="" formControlName="pmfOverproduction">
                      <mat-option *ngFor="let mOverproduction of pmfOverproduction" [value]="mOverproduction">
                        {{mOverproduction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfOverproduction'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>8. In which case do you think customers are dissatisfied with competitors? </label>
                    <mat-select placeholder="" formControlName="pmfCompetitorDissatisfaction" multiple>
                      <mat-option (onSelectionChange)="pmfCDChange($event, mCompetitorDissatisfaction.name)"
                        *ngFor="let mCompetitorDissatisfaction of pmfCompetitorDissatisfaction"
                        [value]="mCompetitorDissatisfaction">
                        {{mCompetitorDissatisfaction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfCompetitorDissatisfaction'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>


            </mat-card-content>
          </div>
          <!-- Busines to Consumer-->
          <div *ngIf="B2C">
            <mat-card-header>
              <mat-card-title>Target Market </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <label>
                <h3>Understanding Your Target Customer</h3>
              </label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>1. What is your main target customer's age range? </label>
                    <mat-select placeholder="" formControlName="marketTargetAge">
                      <mat-option *ngFor="let mTargetAge of marketTargetAge" [value]="mTargetAge">
                        {{ mTargetAge.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetAge'].hasError('required')">
                      Please enter the target age range
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>2. What is your main target customer's ethnicity?</label>
                    <mat-select placeholder="" formControlName="marketTargetEthnicity">
                      <mat-option *ngFor="let mTargetEthnicity of marketTargetEthnicity" [value]="mTargetEthnicity">
                        {{ mTargetEthnicity.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetEthnicity'].hasError('required')">
                      Please enter the target ethnic group
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>3. What is your main target customer's gender?</label>
                    <mat-select placeholder="" formControlName="marketTargetGender">
                      <mat-option *ngFor="let mTargetGender of marketTargetGender" [value]="mTargetGender">
                        {{ mTargetGender.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetGender'].hasError('required')">
                      Please enter the target gender
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>4. What is your main target customer's occupation?</label>
                    <mat-select placeholder="" formControlName="marketTargetOccupation">
                      <mat-option *ngFor="let mTargetOccupation of marketTargetOccupation" [value]="mTargetOccupation">
                        {{ mTargetOccupation.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetOccupation'].hasError('required')">
                      Please enter the target occupation
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>5. What's the largest market location you target? </label>
                    <mat-select placeholder="" formControlName="marketTargetLocation">
                      <mat-option *ngFor="let mTargetLocation of marketTargetLocation" [value]="mTargetLocation">
                        {{mTargetLocation.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetLocation'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <label>
                <h3>Understanding Your Competitors</h3>
              </label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>6. How many competitors, or substitutes, do you have? </label>
                    <mat-select placeholder="" formControlName="pmfOverproduction">
                      <mat-option *ngFor="let mOverproduction of pmfOverproduction" [value]="mOverproduction">
                        {{mOverproduction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfOverproduction'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
               <!-- <div class="col">
                  <mat-form-field class="full-width">
                    <label>7. In what demand do you think customers are purchasing from your competitors?</label>
                    <mat-select placeholder="" formControlName="pmfCompetitorDemand">
                      <mat-option *ngFor="let mCompetitorDemand of pmfCompetitorDemand" [value]="mCompetitorDemand">
                        {{mCompetitorDemand.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfCompetitorDemand'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>-->
              </div>
              <div class="row">
              <!-- <div class="col">
                  <mat-form-field class="full-width">
                    <label>8. How satisfied do you think customers are with your competitor's product or
                      service?</label>
                    <mat-select placeholder="" formControlName="pmfCompetitorSatisfaction">
                      <mat-option *ngFor="let mCompetitorSatisfaction of pmfCompetitorSatisfaction"
                        [value]="mCompetitorSatisfaction">
                        {{mCompetitorSatisfaction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfCompetitorSatisfaction'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>--> 
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>9. In which case do you think customers are dissatisfied with competitors? </label>
                    <mat-select placeholder="" formControlName="pmfCompetitorDissatisfaction" multiple>
                      <mat-option (onSelectionChange)="pmfCDChange($event, mCompetitorDissatisfaction.name)"
                        *ngFor="let mCompetitorDissatisfaction of pmfCompetitorDissatisfaction"
                        [value]="mCompetitorDissatisfaction">
                        {{mCompetitorDissatisfaction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfCompetitorDissatisfaction'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
              </div>

            </mat-card-content>
          </div>
        </mat-card>
        <button type="button" mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button"
          (click)="nextTab()">Next
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button type="button" mat-raised-button class="btn-blue-royal prv-btn" color="primary" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon> Previous
        </button>
      </mat-tab>

      <!--Revenue-->
      <mat-tab label="Revenue">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Revenue Model</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>1. How are you making (or plan to make) money?</label>
                  <mat-select placeholder="" formControlName="revModel" multiple>
                    <mat-option *ngFor="let rModel of revModel" [value]="rModel">
                      {{ rModel.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['revModel'].hasError('required')">
                    Please enter the revenue model
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <mat-form-field class="full-width">
                  <label>2. Are you looking for financing or capital?</label>
                  <mat-select placeholder=" " formControlName="capitalSeeking">
                    <mat-option *ngFor="let cSeeking of boolAnswer" [value]="cSeeking">
                      {{ cSeeking.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['capitalSeeking']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>Starting Financials</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>3. How much money do you have to start the business?
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revInitialCapital">
                  <mat-error *ngIf="assessmentForm.controls['revInitialCapital'].hasError('required')">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>4. How much money do you need to start the business?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Ex. The amount of money needed to start the business">info</mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revStartingCosts">
                  <mat-error *ngIf="assessmentForm.controls['revStartingCosts'].hasError('required')">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>5. How much revenue do you make (or expect to make) per sale, on average?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Ex. I make about $30 per pizza order">info
                    </mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revPerUser">
                  <mat-error *ngIf="assessmentForm.controls['revPerUser'].hasError('required')">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>6. How much money goes (or will go) into making the product or service per sale, on average?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Cost of goods sold. Ex. It takes $10 to produce the pizza order">info</mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revCOGS">
                  <mat-error *ngIf="assessmentForm.controls['revCOGS'].hasError('required')">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>7. How much are your fixed monthly costs to run the business?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Ex. Lights, rent, wifi, etc.">info</mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revFixedCostPerMonth">
                  <mat-error *ngIf="assessmentForm.controls['revFixedCostPerMonth'].hasError('required')">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>8. How many customers do you anticipate in the first month of operating?
                    <mat-icon matSuffix matTooltip="Ex. I anticipate 30 pizza orders in the first month">info</mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revInitUsers">
                  <mat-error *ngIf="assessmentForm.controls['revInitUsers'].hasError('required')">
                    Number of Initial Customers
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>9. What is your monthly revenue growth goal (%)?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Ex. I hope to grow 5% in the second month">info
                    </mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revMonthlyUserGrowth">
                  <mat-error *ngIf="assessmentForm.controls['revMonthlyUserGrowth'].hasError('required')">
                    Estimated Monthly Customer Growth (%) is
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>10. What percentage of customers, do you estimate, won't become return customers?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Ex. I'm buffering for 2% customer loss per month">info</mat-icon>
                  </label>
                  <input matInput type="number" placeholder="" formControlName="revMonthlyUserLoss">
                  <mat-error *ngIf="assessmentForm.controls['revMonthlyUserLoss'].hasError('required')">
                    Estimated Monthly Customer Loss (%)
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!--  <label>Starting Financing</label>
    <div class="row">
    <div class="col">
    <mat-form-field class="full-width">
    <input matInput type="number" placeholder="We expect to have this amount of our own cash at the beginning of Month 1 ($) "  formControlName = "revStartingCash">
    <mat-error *ngIf="assessmentForm.controls['revStartingCash']">
    Please enter average dollar amount
  </mat-error>
</mat-form-field>
</div>
</div>-->

          </mat-card-content>
        </mat-card>
        <button mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button" (click)="nextTab()">Next
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button mat-raised-button class="btn-blue-royal prv-btn" color="primary" type="button" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon>Previous
        </button>
      </mat-tab>

      <!--Team-->
      <mat-tab label="Team">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Team Dynamics</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <label>
              <h3>Existing Company Record</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>1a. Is this an existing company?</label>
                  <mat-select placeholder=" " formControlName="teamExistingCompany">
                    <mat-option (onSelectionChange)="handleQ2($event, tExistingCompany.name)"
                      *ngFor="let tExistingCompany of boolAnswer" [value]="tExistingCompany">
                      {{ tExistingCompany.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamExistingCompany']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" #existingBase style="display:none">
                <mat-form-field class="full-width">
                  <label>1b. Do you have an existing customer base?</label>
                  <mat-select placeholder="" formControlName="teamExistingCustomerBase">
                    <mat-option (onSelectionChange)="handleQ3($event, tExistingCustomerBase.name)"
                      *ngFor="let tExistingCustomerBase of boolAnswer" [value]="tExistingCustomerBase">
                      {{ tExistingCustomerBase.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamExistingCustomerBase']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" #existingProd style="display:none">
                <mat-form-field class="full-width">
                  <label>1c. Is this product or service similar to your other products or services?</label>
                  <mat-select placeholder="" formControlName="teamExistingProdListing">
                    <mat-option *ngFor="let tExistingProdListing of boolAnswer" [value]="tExistingProdListing">
                      {{ tExistingProdListing.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamExistingProdListing']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>2. Has anyone on the core or executive team started or managed a business before?</label>
                  <mat-select placeholder="" formControlName="teamLeaderSerialEntrp">
                    <mat-option *ngFor="let tLeaderSerialEntrp of boolAnswer" [value]="tLeaderSerialEntrp">
                      {{ tLeaderSerialEntrp.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamLeaderSerialEntrp']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>What is the Team's Technical Capability?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>3. What skills are your team strong in?</label>
                  <mat-select placeholder="" formControlName="teamRole" multiple>
                    <mat-option *ngFor="let tRole of teamRole" [value]="tRole">
                      {{ tRole.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamRole']">
                    Please select all that apply
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>4. How many team members are currently working on the business?</label>
                  <input matInput type="number" placeholder="" formControlName="teamMembersQuan"
                    [(ngModel)]="teamMembersQuanCheck" (change)="hideQ15to17()">
                  <mat-error *ngIf="assessmentForm.controls['teamMembersQuan']">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>5. How well does the team know the business industry? </label>
                  <mat-icon class="matTooltip" matSuffix
                    matTooltip=" Industry knowledge is background or experience in the field">info
                  </mat-icon>
                  <mat-select placeholder="" formControlName="teamIndustryKnowledge">
                    <mat-option *ngFor="let tIndustryKnowledge of teamIndustryKnowledge" [value]="tIndustryKnowledge">
                      {{ tIndustryKnowledge.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamIndustryKnowledge']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>6. How much time do most team members have to dedicate to the business per week? </label>
                  <mat-select placeholder="" formControlName="teamTime">
                    <mat-option *ngFor="let tTime of teamTime" [value]="tTime">
                      {{ tTime.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTime']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>What is the Execution Ability of the Team?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>7. What is the ability of the team to develop or sell the product or service through its
                    network?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip=" Think about the ability to develop the product/service and sales funnels.">info
                    </mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="teamNetwork">
                    <mat-option *ngFor="let tNetwork of teamNetwork" [value]="tNetwork">
                      {{tNetwork.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamNetwork'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
             <!-- <div class="col">
                <mat-form-field class="full-width">
                  <label>8. How useful are the team’s mentors in helping build the business?</label>
                  <mat-icon class="matTooltip" matSuffix
                    matTooltip=" An industry mentor is someone who has years worth of experience in the field">info
                  </mat-icon>
                  <mat-select placeholder="" formControlName="teamMentors">
                    <mat-option *ngFor="let tMentors of teamMentors" [value]="tMentors">
                      {{ tMentors.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamMentors']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <label>8. What challenges have you already overcome to start the business? Select all that apply
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip=" Unfair advantages are the market barriers (selected above) that the team has already overcome">
                      info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="teamUnadv" multiple>
                    <mat-option (onSelectionChange)="teamUnadvChange($event, tUnfairAdvantage.name)"
                      *ngFor="let tUnfairAdvantage of teamUnadv" [value]=" teamUnadv">
                      {{ tUnfairAdvantage.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamUnadv'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!--   <div class="row">
           
            <div class="col">
                <mat-form-field class="full-width">
                  <label>11. How often does the team end meetings with a clear path forward or call to action?</label>
                  <mat-select placeholder="" formControlName="teamCTA">
                    <mat-option *ngFor="let tCTA of teamCTA" [value]="tCTA">
                      {{tCTA.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamCTA'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>-->
            <div class="row">
              <!-- <div class="col">
                <mat-form-field class="full-width">
                  <label>12. If it arises, how frequent does the team address and solve internal conflict? </label>
                  <mat-select placeholder="" formControlName="teamConflict">
                    <mat-option *ngFor="let tConflict of teamConflict" [value]="tConflict">
                      {{tConflict.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamConflict'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <label>9. What is the team’s ability to set, prioritize, track and meet goals when given a
                    timeline?</label>
                  <mat-select placeholder="" formControlName="teamTimeManage">
                    <mat-option *ngFor="let tTimeManage of teamTimeManage" [value]="tTimeManage">
                      {{tTimeManage.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTimeManage'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>10. How accountable are the team members to the team and its progress?</label>
                  <mat-select placeholder="" formControlName="teamAccountability">
                    <mat-option *ngFor="let tAccountability of teamAccountability" [value]="tAccountability">
                      {{tAccountability.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamAccountability'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>11. How often does the team encounter internal dysfunction or unproductivity?</label>
                  <mat-select placeholder="" formControlName="teamUnproductivity">
                    <mat-option *ngFor="let tProductivity of teamUnproductivity" [value]="tProductivity">
                      {{tProductivity.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamUnproductivity'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>What is the Team Disposition?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>12. How passionate is the team about the business?</label>
                  <mat-select placeholder="" formControlName="teamPassion">
                    <mat-option *ngFor="let tPassion of teamPassion" [value]="tPassion">
                      {{tPassion.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamPassion'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>13. How well can the team handle risk if faced?</label>
                  <mat-select placeholder=" " formControlName="teamRisk">
                    <mat-option *ngFor="let tRisk of teamRisk" [value]="tRisk">
                      {{ tRisk.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamRisk']">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="teamMemberHTMLVar">
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>14. At what level does the team agree with the statement “Team members openly admit mistakes
                      or
                      problems”?</label>
                    <mat-select placeholder="" formControlName="teamOpenness">
                      <mat-option *ngFor="let tOpenness of teamOpenness" [value]="tOpenness">
                        {{ tOpenness.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamOpenness']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>15. At what level does the team agree with the statement, “We have confidence in each other’s
                      ability to get stuff done”?</label>
                    <mat-select placeholder="" formControlName="teamTrust">
                      <mat-option *ngFor="let tTrust of teamTrust" [value]="tTrust">
                        {{ tTrust.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamTrust']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>16. At what level does the team agree with the statement “the team rewards or recognizes team
                      member contributions, big and small”?</label>
                    <mat-select placeholder="" formControlName="teamRecognition">
                      <mat-option *ngFor="let tRecognition of teamRecognition" [value]="tRecognition">
                        {{ tRecognition.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamRecognition']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <mat-checkbox formControlName="acceptTerms" #tc>
                      By selecting 'I agree' and clicking submit, you agree to our <a target="_blank"
                        href="http://sustainible.io/privacy-policy/">Privacy Policy</a> and <a target="_blank"
                        href="http://sustainible.io/terms-conditions/">Terms and Conditions</a>.
                    </mat-checkbox>
                    <mat-error *ngIf="tc.checked">
                      <button class="btn-block btn-blue-royal" mat-raised-button color="primary">Submit</button>
                    </mat-error>
                  </div>
                </div>
                <!--<mat-form-field class="full-width">
          <label>By selecting 'I agree' and clicking submit, you agree to our  <a target="_blank" href="http://sustainible.io/privacy-policy/">Privacy Policy</a> and  <a target="_blank" href="http://sustainible.io/terms-conditions/">Terms and Conditions</a>.
          </label>
          <mat-select placeholder=" "  formControlName = "acceptTerms" >
            <mat-option *ngFor="let aTerms of acceptTerms" [value]="aTerms">
                {{ aTerms.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="assessmentForm.controls['acceptTerms']">
            Required
          </mat-error>
        </mat-form-field>-->
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <button mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon>Previous
        </button>
      </mat-tab>

    </mat-tab-group>
  </div>

</form>
